import { NavLink } from "react-router-dom";
import "../style/policy.css";

export default function PolicyPageLayout({ eyebrow, title, description, sections }) {
  return (
    <main className="policy-page">
      <section className="policy-card">
        <span className="policy-eyebrow">{eyebrow}</span>
        <h1>{title}</h1>
        <p className="policy-description">{description}</p>

        <div className="policy-section-list">
          {sections.map((section) => (
            <section className="policy-section" key={section.title}>
              <h2>{section.title}</h2>
              {section.body.map((paragraph) => (
                <p key={paragraph}>{paragraph}</p>
              ))}
            </section>
          ))}
        </div>

        <div className="policy-cta">
          <div>
            <strong>Need help?</strong>
            <span>Contact QA Coder for policy, course, or support questions.</span>
          </div>
          <NavLink to="/contact">Contact Us</NavLink>
        </div>
      </section>
    </main>
  );
}
